/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { agentVersionsListAgentVersions } from "../../funcs/agentVersionsListAgentVersions.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.ListAgentVersionsRequest$inboundSchema,
};

export const tool$agentVersionsListAgentVersions: ToolDefinition<typeof args> =
  {
    name: "agent-versions-list-agent-versions",
    description: `List agent versions

Lists the configuration history for an agent. Each committed change (create, update, rollback) appends a version.`,
    args,
    tool: async (client, args, ctx) => {
      const [result, apiCall] = await agentVersionsListAgentVersions(
        client,
        args.request,
        { fetchOptions: { signal: ctx.signal } },
      ).$inspect();

      if (!result.ok) {
        return {
          content: [{ type: "text", text: result.error.message }],
          isError: true,
        };
      }

      const value = result.value;

      return formatResult(value, apiCall);
    },
  };
